export default template;
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (isNew, isReset) {pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Ch3\u003E";
if (isNew) {
pug_html = pug_html + "Welcome to TALC!";
}
else {
pug_html = pug_html + "Change password";
}
pug_html = pug_html + "\u003C\u002Fh3\u003E\u003Cform class=\"with-validation change-password-form\"\u003E";
if (isNew) {
pug_html = pug_html + "\u003Cp\u003EPlease set a password for your TALC account.\u003C\u002Fp\u003E";
}
var title = isNew ? "Password" : "New password";
if ((! isReset)) {
pug_html = pug_html + "\u003Clabel\u003ECurrent password\u003C\u002Flabel\u003E\u003Cinput type=\"password\" name=\"currentPassword\" required\u003E";
}
pug_html = pug_html + "\u003Clabel\u003E" + (pug_escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003Cinput type=\"password\" name=\"newPassword\" required id=\"newPassword\"\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = title) ? "" : pug_interp)) + " (repeat)\u003C\u002Flabel\u003E\u003Cinput type=\"password\" name=\"newPassword2\" required equalTo=\"#newPassword\"\u003E\u003Cbutton class=\"change-password action update\" type=\"button\"\u003E";
if (isNew) {
pug_html = pug_html + "Set password";
}
else {
pug_html = pug_html + "Update password";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";}.call(this,"isNew" in locals_for_with?locals_for_with.isNew:typeof isNew!=="undefined"?isNew:undefined,"isReset" in locals_for_with?locals_for_with.isReset:typeof isReset!=="undefined"?isReset:undefined));;return pug_html;}